'use client'
import {
  getContentfulSafeLocale
} from "./chunk-IIMDQLWJ.mjs";
import {
  gqlClient
} from "./chunk-4T365VQK.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/city/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getCity = (props) => __async(null, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getCity($lang: String, $limit: Int, $skip: Int, $search: String, $where: CityFilter) {
          cityCollection(
            locale: $lang
            limit: $limit
            skip: $skip
            search: $search
            where: $where
          ) {
            items {
              id
              title
              cityCode
              supported
              linkedFrom {
                countryCollection(limit: 1) {
                  items {
                    title
                    countryCode
                  }
                }
              }
            }
          }
        }
      `,
      __spreadProps(__spreadValues({}, props), {
        lang: getContentfulSafeLocale(props.lang)
      })
    );
    return res.cityCollection.items;
  } catch (error) {
    throw new Exception({ error, name: "getCity" });
  }
});
var useGetCity = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getCity", props],
    queryFn: () => getCity(props)
  }, options));
};

export {
  useGetCity
};
//# sourceMappingURL=chunk-BPGTMBWX.mjs.map